/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import Immutable from "seamless-immutable";
import {
  CLEAR_ORDER_INDICATOR,
  GET_USER_CART_ITEM_REQUEST,
  GET_USER_QUEUE_COMPLETE_ITEM_FAILURE,
  GET_USER_QUEUE_COMPLETE_ITEM_REQUEST,
  GET_USER_QUEUE_COMPLETE_ITEM_SUCCESS,
  GET_USER_QUEUE_LIST_FAILURE,
  GET_USER_QUEUE_LIST_REQUEST,
  GET_USER_QUEUE_LIST_SUCCESS,
  GET_USER_QUEUE_READY_ITEM_FAILURE,
  GET_USER_QUEUE_READY_ITEM_REQUEST,
  GET_USER_QUEUE_READY_ITEM_SUCCESS,
  POST_USER_ORDER_PAYMENT_FAILURE,
  POST_USER_ORDER_PAYMENT_REQUEST,
  POST_USER_ORDER_PAYMENT_SUCCESS,
  UPDATE_ORDER_SUMMARY_TABLE_REQUEST,
  UPDATE_ORDER_SUMMARY_TABLE_SUCCESS,
  UPDATE_ORDER_SUMMARY_TABLE_FAILURE,
  UPDATE_CHANGE_TABLE_MODAL_REQUEST,
  SET_BALANCE_ERROR
} from "../actions/user";
import { GET_USER_CART_ITEM_SUCCESS } from "../actions/user";
import { GET_USER_CART_ITEM_FAILURE } from "../actions/user";
import { DELETE_USER_CART_ITEM_REQUEST } from "../actions/user";
import { DELETE_USER_CART_ITEM_SUCCESS } from "../actions/user";
import { DELETE_USER_CART_ITEM_FAILURE } from "../actions/user";
import { APPLY_USER_CART_WALLET_REQUEST } from "../actions/user";
import { APPLY_USER_CART_WALLET_SUCCESS } from "../actions/user";
import { APPLY_USER_CART_WALLET_FAILURE } from "../actions/user";
import { APPLY_USER_CART_POINT_REQUEST } from "../actions/user";
import { APPLY_USER_CART_POINT_SUCCESS } from "../actions/user";
import { APPLY_USER_CART_POINT_FAILURE } from "../actions/user";
import { ADD_USER_CART_FOOD_REQUEST } from "../actions/user";
import { ADD_USER_CART_FOOD_SUCCESS } from "../actions/user";
import { ADD_USER_CART_FOOD_FAILURE } from "../actions/user";
import { EDIT_USER_CART_FOOD_REQUEST } from "../actions/user";
import { EDIT_USER_CART_FOOD_SUCCESS } from "../actions/user";
import { EDIT_USER_CART_FOOD_FAILURE } from "../actions/user";
import { UPDATE_USER_CART_FOOD_DELIVERY_REQUEST } from "../actions/user";
import { UPDATE_USER_CART_FOOD_DELIVERY_SUCCESS } from "../actions/user";
import { UPDATE_USER_CART_FOOD_DELIVERY_FAILURE } from "../actions/user";
import { GET_USER_ORDER_DETAIL_REQUEST } from "../actions/user";
import { GET_USER_ORDER_DETAIL_SUCCESS } from "../actions/user";
import { GET_USER_ORDER_DETAIL_FAILURE } from "../actions/user";
import { CHECKOUT_USER_CART_REQUEST } from "../actions/user";
import { CHECKOUT_USER_CART_SUCCESS } from "../actions/user";
import { CHECKOUT_USER_CART_FAILURE } from "../actions/user";
import { SET_DELIVERY_STATUS } from "../actions/user";
import { RESET_CART_STATE } from "../actions/user";
import { UPDATE_USER_ORDER_TABLE_REQUEST } from "../actions/user";
import { UPDATE_USER_ORDER_TABLE_SUCCESS } from "../actions/user";
import { UPDATE_USER_ORDER_TABLE_FAILURE } from "../actions/user";
import { GET_USER_ORDER_LIST_REQUEST } from "../actions/user";
import { GET_USER_ORDER_LIST_SUCCESS } from "../actions/user";
import { SET_ORDER_INDICATOR } from "../actions/user";
import { UPDATE_USER_ORDER_PAYMENT_FAILURE } from "../actions/user";
import { UPDATE_USER_ORDER_PAYMENT_SUCCESS } from "../actions/user";
import { UPDATE_USER_ORDER_PAYMENT_REQUEST } from "../actions/user";
import { CANCEL_USER_ORDER_FAILURE } from "../actions/user";
import { CANCEL_USER_ORDER_SUCCESS } from "../actions/user";
import { CANCEL_USER_ORDER_REQUEST } from "../actions/user";
import { GET_USER_ORDER_LIST_FAILURE } from "../actions/user";
import OrderManager from "../utils/OrderManager";

const INITIAL_STATE = Immutable({
  cart: null,
  cartLoading: false,
  deleteCart: null,
  requestCart: null,
  apply: null,
  order: {
    indicator: OrderManager.retrieveOrderIndicator()
  },
  table: null,
  queue: null
});

function user(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_USER_CART_ITEM_REQUEST:
      return state.setIn(["cartLoading"], true);
    case GET_USER_CART_ITEM_SUCCESS:
      return state
        .setIn(["cartLoading"], false)
        .setIn(["cart", "item"], action.data);
    case GET_USER_CART_ITEM_FAILURE:
      return state.setIn(["cartLoading"], false);
    case DELETE_USER_CART_ITEM_REQUEST:
      return state
        .setIn(["deleteCart", "loading"], true)
        .setIn(["deleteCart", "status"], false);
    case DELETE_USER_CART_ITEM_SUCCESS:
      return state
        .setIn(["deleteCart", "loading"], false)
        .setIn(["deleteCart", "status"], true)
        .setIn(["cart", "item"], action.data);
    case DELETE_USER_CART_ITEM_FAILURE:
      return state
        .setIn(["deleteCart", "loading"], false)
        .setIn(["deleteCart", "status"], false);
    case APPLY_USER_CART_WALLET_REQUEST:
      return state
        .setIn(["apply", "wallet", "loading"], true)
        .setIn(["apply", "wallet", "status"], false);
    case APPLY_USER_CART_WALLET_SUCCESS:
      return state
        .setIn(["apply", "wallet", "loading"], false)
        .setIn(["apply", "wallet", "status"], true)
        .setIn(["cart", "item"], action.data);
    case APPLY_USER_CART_WALLET_FAILURE:
      return state
        .setIn(["apply", "wallet", "loading"], false)
        .setIn(["apply", "wallet", "status"], false);
    case APPLY_USER_CART_POINT_REQUEST:
      return state
        .setIn(["apply", "point", "loading"], true)
        .setIn(["apply", "point", "status"], false);
    case APPLY_USER_CART_POINT_SUCCESS:
      return state
        .setIn(["apply", "point", "loading"], false)
        .setIn(["apply", "point", "status"], true)
        .setIn(["cart", "item"], action.data);
    case APPLY_USER_CART_POINT_FAILURE:
      return state
        .setIn(["apply", "point", "loading"], false)
        .setIn(["apply", "point", "status"], false);
    case ADD_USER_CART_FOOD_REQUEST:
      return state
        .setIn(["requestCart", "add", "loading"], true)
        .setIn(["requestCart", "add", "status"], false);
    case ADD_USER_CART_FOOD_SUCCESS:
      return state
        .setIn(["requestCart", "add", "loading"], false)
        .setIn(["requestCart", "add", "status"], true)
        .setIn(["cart", "item"], action.data);
    case ADD_USER_CART_FOOD_FAILURE:
      return state
        .setIn(["requestCart", "add", "loading"], false)
        .setIn(["requestCart", "add", "status"], false);
    case EDIT_USER_CART_FOOD_REQUEST:
      return state
        .setIn(["requestCart", "edit", "loading"], true)
        .setIn(["requestCart", "edit", "status"], false);
    case EDIT_USER_CART_FOOD_SUCCESS:
      return state
        .setIn(["requestCart", "edit", "loading"], false)
        .setIn(["requestCart", "edit", "status"], true)
        .setIn(["cart", "item"], action.data);
    case EDIT_USER_CART_FOOD_FAILURE:
      return state
        .setIn(["requestCart", "edit", "loading"], false)
        .setIn(["requestCart", "edit", "status"], false);
    case UPDATE_USER_CART_FOOD_DELIVERY_REQUEST:
      return state.setIn(["requestCart", "edit", "loading"], true);
    case UPDATE_USER_CART_FOOD_DELIVERY_SUCCESS:
      return state
        .setIn(["requestCart", "edit", "loading"], false)
        .setIn(["cart", "item"], action.data);
    case UPDATE_USER_CART_FOOD_DELIVERY_FAILURE:
      return state.setIn(["requestCart", "edit", "loading"], false);
    case GET_USER_ORDER_DETAIL_REQUEST:
      return state.setIn(["order", "orderDetail", "loading"], true);
    case GET_USER_ORDER_DETAIL_SUCCESS:
      return state
        .setIn(["order", "orderDetail", "loading"], false)
        .setIn(["order", "orderDetail", "item"], action.data);
    case GET_USER_ORDER_DETAIL_FAILURE:
      return state.setIn(["order", "orderDetail", "loading"], false);
    case CHECKOUT_USER_CART_REQUEST:
      return state
        .setIn(["cart", "error"], false)
        .setIn(["checkout", "status"], false)
        .setIn(["checkout", "loading"], true);
    case CHECKOUT_USER_CART_SUCCESS:
      return state
        .setIn(["checkout", "status"], true)
        .setIn(["checkout", "loading"], false)
        .setIn(["checkout", "item"], action.data)
        .setIn(["cart", "item"], null);
    case CHECKOUT_USER_CART_FAILURE:
      return state
        .setIn(["checkout", "status"], false)
        .setIn(["checkout", "loading"], false);
    case SET_DELIVERY_STATUS:
      const { cart } = state;
      let newItem = cart.item;
      let newCart =
        newItem &&
        newItem.stall &&
        newItem.stall.items &&
        newItem.stall.items.map(stallItem => {
          let newStallItem = stallItem;

          newStallItem =
            stallItem && stallItem.items
              ? stallItem.items.map(cartItem => {
                  if (cartItem.id === action.cartID) {
                    let newAttribute = {
                      ...cartItem.attribute,
                      is_delivery: action.status
                    };
                    return {
                      ...cartItem,
                      attribute: newAttribute
                    };
                  } else {
                    return cartItem;
                  }
                })
              : false;

          return {
            ...stallItem,
            items: [...newStallItem]
          };
        });
      let result = {
        ...newItem,
        stall: {
          items: [...newCart]
        }
      };
      return state.setIn(["cart", "item"], result);
    case RESET_CART_STATE:
      return state.setIn(["cart"], null);
    case UPDATE_USER_ORDER_TABLE_REQUEST:
      return state.setIn(["table", "loading"], true);
    case UPDATE_USER_ORDER_TABLE_SUCCESS:
      return state
        .setIn(["table", "loading"], false)
        .setIn(["cart", "item"], action.data);
    case UPDATE_USER_ORDER_TABLE_FAILURE:
      return state.setIn(["table", "loading"], false);
    case GET_USER_ORDER_LIST_REQUEST:
      if (action.hideLoading) {
        return state
          .setIn(["order", "list", "hideLoading"], true)
          .setIn(["order", "list", "loading"], true);
      }
      return state.setIn(["order", "list", "loading"], true);
    case GET_USER_ORDER_LIST_SUCCESS:
      const { currentPage } = action.pagination;
      const { order } = state;

      return state
        .setIn(
          ["order", "list", "items"],
          order && order.list && order.list.items && currentPage > 1
            ? order.list.items.concat(action.data)
            : action.data
        )
        .setIn(["order", "list", "pagination"], action.pagination)
        .setIn(["order", "list", "hideLoading"], false)
        .setIn(["order", "list", "loading"], false);
    case GET_USER_ORDER_LIST_FAILURE:
      return state
        .setIn(["order", "list", "hideLoading"], false)
        .setIn(["order", "list", "loading"], false);
    case CANCEL_USER_ORDER_REQUEST:
      return state
        .setIn(["order", "cancel", "loading"], true)
        .setIn(["order", "cancel", "status"], false);
    case CANCEL_USER_ORDER_SUCCESS:
      return state
        .setIn(["order", "cancel", "loading"], false)
        .setIn(["order", "cancel", "status"], true);
    case CANCEL_USER_ORDER_FAILURE:
      return state
        .setIn(["order", "cancel", "loading"], false)
        .setIn(["order", "cancel", "status"], false);
    case UPDATE_USER_ORDER_PAYMENT_REQUEST:
      return state.setIn(["order", "updatePaymentLoading"], true);
    case UPDATE_USER_ORDER_PAYMENT_SUCCESS:
      return state
        .setIn(["order", "updatePaymentLoading"], false)
        .setIn(["order", "orderDetail", "item"], action.data);
    case UPDATE_USER_ORDER_PAYMENT_FAILURE:
      return state.setIn(["order", "updatePaymentLoading"], false);
    case POST_USER_ORDER_PAYMENT_REQUEST:
      return state
        .setIn(["order", "updatePaymentLoading"], true)
        .setIn(["order", "createPayment", "status"], false);
    case POST_USER_ORDER_PAYMENT_SUCCESS:
      return state
        .setIn(["order", "updatePaymentLoading"], false)
        .setIn(["order", "createPayment", "item"], action.item)
        .setIn(["order", "createPayment", "status"], action.success);
    case POST_USER_ORDER_PAYMENT_FAILURE:
      return state
        .setIn(["order", "updatePaymentLoading"], false)
        .setIn(["order", "createPayment", "status"], false);
    case SET_ORDER_INDICATOR:
      return state.setIn(["order", "indicator"], true);
    case CLEAR_ORDER_INDICATOR:
      return state.setIn(["order", "indicator"], false);
    case GET_USER_QUEUE_LIST_REQUEST:
      if (action.loading === true) {
        return state.setIn(["queue", "progress", "loading"], true);
      }
      return state;
    case GET_USER_QUEUE_LIST_SUCCESS:
      return state
        .setIn(["queue", "progress", "item"], action.data)
        .setIn(["queue", "progress", "loading"], false);
    case GET_USER_QUEUE_LIST_FAILURE:
      return state.setIn(["queue", "progress", "loading"], false);
    case GET_USER_QUEUE_READY_ITEM_REQUEST:
      if (action.loading === true) {
        return state.setIn(["queue", "ready", "loading"], true);
      }
      return state;
    case GET_USER_QUEUE_READY_ITEM_SUCCESS:
      return state
        .setIn(["queue", "ready", "item"], action.data)
        .setIn(["queue", "ready", "loading"], false);
    case GET_USER_QUEUE_READY_ITEM_FAILURE:
      return state.setIn(["queue", "ready", "loading"], false);
    case GET_USER_QUEUE_COMPLETE_ITEM_REQUEST:
      if (action.loading === true) {
        return state.setIn(["queue", "complete", "loading"], true);
      }
      return state;
    case GET_USER_QUEUE_COMPLETE_ITEM_SUCCESS:
      return state
        .setIn(["queue", "complete", "item"], action.data)
        .setIn(["queue", "complete", "loading"], false);
    case GET_USER_QUEUE_COMPLETE_ITEM_FAILURE:
      return state.setIn(["queue", "complete", "loading"], false);
    case UPDATE_ORDER_SUMMARY_TABLE_REQUEST:
      return state.setIn(["order", "orderDetail", "loading"], true);
    case UPDATE_ORDER_SUMMARY_TABLE_SUCCESS:
      return state
        .setIn(["order", "orderDetail", "loading"], false)
        .setIn(["order", "orderDetail", "changeTableModal"], false);
    case UPDATE_ORDER_SUMMARY_TABLE_FAILURE:
      return state
        .setIn(["order", "orderDetail", "loading"], false)
        .setIn(["order", "orderDetail", "changeTableModal"], true);
    case UPDATE_CHANGE_TABLE_MODAL_REQUEST:
      return state.setIn(
        ["order", "orderDetail", "changeTableModal"],
        action.status
      );
    case SET_BALANCE_ERROR:
      return state
        .setIn(["checkout", "loading"], false)
        .setIn(["cart", "error"], action.status);
    default:
      return state;
  }
}

export default user;



// WEBPACK FOOTER //
// ./src/reducers/user.js